// Castintech dashboard — Suggestions panel (urgent state ozeti).
// Faz 9b PR9 + Faz 10 PR7 (XSS fix). Faz 13 — strict TS hardening.

import { state } from '../state.js';
import { normStatus, statusCls, getGem, $, asEl } from '../utils.js';
import { navigate } from '../main.js';

interface Suggestion {
  emoji: string;
  text: string;
  sub: string;
  type: 'urgent' | 'good' | 'info';
  action?: () => void;
}

// Modul-scope action cache. renderSuggestions her cagriligi yeniler.
// data-sg-index attribute'undan idx oku, _actions[idx]() cagir.
let _actions: Array<() => void> = [];

function buildSuggestions(): Suggestion[] {
  const sgs: Suggestion[] = [];
  const blocked = state.tasks.filter(t => normStatus(t.status) === 'blocked');
  const active = state.agents.filter(a => ['active', 'running', 'busy'].includes(statusCls(a.status)));
  const pending = state.approvals.filter(a => a.status === 'pending');
  const done24 = state.tasks.filter(t => {
    const s = normStatus(t.status);
    return s === 'done' && t.updatedAt && (Date.now() - new Date(t.updatedAt).getTime()) < 86400000;
  });

  if (pending.length > 0) {
    sgs.push({ emoji: '✅', text: pending.length + ' onay bekliyor', sub: 'Forge/Pilot müdahale bekliyor', type: 'urgent', action: () => navigate('onaylar') });
  }

  if (blocked.length > 0) {
    const oldest = blocked.slice().sort((a, b) => new Date(a.updatedAt || a.created_at || 0).getTime() - new Date(b.updatedAt || b.created_at || 0).getTime())[0];
    const oldestDate = new Date(oldest.updatedAt || oldest.created_at || 0).getTime();
    const h = Math.floor((Date.now() - oldestDate) / 3600000);
    sgs.push({ emoji: '⚠️', text: blocked.length + ' görev blokeli', sub: (oldest.identifier || 'Görev') + ' ' + h + 'sa bekliyor', type: 'urgent' });
  }

  if (done24.length > 0) {
    sgs.push({ emoji: '🎉', text: 'Bugün ' + done24.length + ' görev tamamlandı', sub: 'İyi gidiyor!', type: 'good' });
  }

  if (active.length > 0) {
    sgs.push({ emoji: '⚡', text: active.length + ' ajan çalışıyor', sub: active.map(a => getGem(a.name).name).join(', '), type: 'info' });
  } else {
    sgs.push({ emoji: '😴', text: 'Tüm ajanlar bekliyor', sub: 'Yeni görev atayabilirsin', type: 'info' });
  }

  if (state.agents.length === 0) {
    sgs.push({ emoji: '🔧', text: 'Ajan bulunamadı', sub: 'Paperclip bağlantısını kontrol et', type: 'urgent' });
  }

  return sgs;
}

export function toggleSuggestions(): void {
  state.suggestionsVisible = !state.suggestionsVisible;
  const panel = $('suggestions-panel');
  if (panel) panel.style.display = state.suggestionsVisible ? '' : 'none';
}

export function renderSuggestions(): void {
  const sgs = buildSuggestions();
  const list = $('sg-list');
  const countEl = $('sg-count');
  const urgent = sgs.filter(s => s.type === 'urgent').length;
  if (countEl) countEl.textContent = String(urgent > 0 ? urgent : sgs.length);

  if (!list) return;

  // Faz 10 PR7 — XSS fix: actions modul-scope cache, render her seferinde reset.
  _actions = [];
  list.innerHTML = sgs.map((sg, i) => {
    if (sg.action) _actions[i] = sg.action;
    const idxAttr = sg.action ? `data-sg-index="${i}"` : '';
    return `
    <div class="sg-item ${sg.type}" style="animation-delay:${i * 60}ms;${sg.action ? 'cursor:pointer' : ''}" ${idxAttr}>
      <div class="sg-emoji">${sg.emoji}</div>
      <div class="sg-body">
        <div class="sg-text">${sg.text}</div>
        <div class="sg-sub">${sg.sub}</div>
      </div>
    </div>`;
  }).join('');
}

// Faz 10 PR7 — Suggestions list delegated click. data-sg-index → _actions[idx]().
let _suggestionsDelegated = false;
export function bindSuggestionsDelegation(): void {
  if (_suggestionsDelegated) return;
  const list = $('sg-list');
  if (!list) return;
  list.addEventListener('click', (e: MouseEvent) => {
    const item = asEl(e.target)?.closest<HTMLElement>('[data-sg-index]');
    if (!item || !list.contains(item)) return;
    const idx = Number(item.dataset.sgIndex);
    if (Number.isFinite(idx) && _actions[idx]) _actions[idx]();
  });
  _suggestionsDelegated = true;
}
